import React from 'react';

import { ValidationErrors } from '@/app/features/reports/types/missing-data';
import { ExclusionReasons, ReportTestItem } from '@/app/features/reports/utils/entities';
import { TestSuite } from 'store/src/lib/tests/entity';
import { FieldSettingsMap } from '@app.raytd.com/common/types/fieldSettings';

type TestTileContextValue = {
    item: ReportTestItem;
    testSuite: TestSuite;
    exclusionToggleOperable: boolean;
    missingData: ValidationErrors;
    hasMissingData: boolean;
    showMissingData: boolean;
    hasFastFillErrors: boolean;
    showFastFillQA: boolean;
    hasUnmatchedSegments: boolean;
    status: string;
    exclusionReason: ExclusionReasons;
    fieldSettings?: FieldSettingsMap;
    onExpandTile?: () => void;
    isCommentsOpen: boolean;
    setIsCommentsOpen: (value: boolean | ((prev: boolean) => boolean)) => void;
}

export const TestTileContext = React.createContext<TestTileContextValue>({} as TestTileContextValue);

export const useTestTileContext = (): TestTileContextValue => {
    const context = React.useContext(TestTileContext);
    
    if (!context) {
        throw new Error('useTestTileContext must be used within a TestTileContext.Provider');
    }
    
    return context;
};
